import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import img1 from "../../../assets/images/small/img-2.jpg"
import img2 from "../../../assets/images/small/img-6.jpg"
import img3 from "../../../assets/images/small/img-1.jpg"
import { Link } from "react-router-dom"
import { FaWhatsapp } from "react-icons/fa"
import Slidewithcaption from "pages/Ui/CarouselTypes/slidewithcaption"
import Webstories from "pages/Webstories/Webstories"
import Footer from "components/VerticalLayout/Footer"

const BlogGrid = () => {
  const [activeTab, toggleTab] = useState("1")

  const toggle = tab => {
    if (activeTab !== tab) toggleTab(tab)
  }

  const cardStyle = {
    background: "rgba(255, 255, 255, 0.1)",
    border: "none",
    borderRadius: "15px",
  };
  const navLinkStyle = {
    color: "#9e9e9e", // Light gray for inactive tabs
  };

  const activeNavLinkStyle = {
    color: "#ffffff", // White for active tabs
    fontWeight: "bold", // Emphasized text
    borderBottom: "2px solid #ffffff", // Highlight the active tab
  };

  const textPrimaryStyle = {
    color: "#65d6ff", // Bright accent color for links
  };

  const paginationStyle = {
    backgroundColor: "rgba(26, 3, 58, 0.5)", // Matching pagination background
    border: "1px solid rgba(255, 255, 255, 0.3)", // Subtle border
    color: "#ffffff", // Light text
  };

  const phoneNumber = "+919586363303";

  // Function to generate the WhatsApp URL with the current page URL
  const generateWhatsAppLink = () => {
    const currentPageURL = window.location.href; // Get the current page URL
    const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };


  useEffect(() => {
    // Dynamically load the widget script
    const script = document.createElement("script");
    script.src = "https://ocpomni.alendei.io/js/widget/mzzpadohxkpzkhtr/float.js";
    script.id = "wa-widget";
    script.setAttribute("widget-id", "aaa5le"); // works as custom attribute
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup when component unmounts
      document.body.removeChild(script);
    };
  }, []);
  return (
    <React.Fragment>
      <Col xl={12} lg={8}>
        <Card style={cardStyle}>
          <TabContent className="p-4" activeTab={activeTab}>
            <TabPane tabId="1">
              <div>
                <Row className="justify-content-center">
                  <Col xl={8}>
                    <div>
                      <div className="row align-items-center">
                        <div className="col-4">
                          <div>
                            <h5 className="mb-0 text-light">Blogs</h5>
                          </div>
                        </div>
                      </div>

                      <hr className="mb-2" />

                      <Row>
                        <Col lg={8}>
                          <Card className="text-light" style={{ backgroundColor: '#1E253A' }}>
                            <CardBody >
                              <CardTitle>What is Jantri?</CardTitle>
                              <CardSubtitle className="mb-3">
                                The Jantri system ensures transparency in Gujarat's property transactions, providing both buyers and sellers a clear framework for fair valuation and associated costs.
                              </CardSubtitle>
                              <Slidewithcaption />
                            </CardBody>
                          </Card>
                        </Col>
                        <Col lg={4}>
                          <Card className="p-0"
                            style={{
                              backgroundColor: "#1E253A",
                              // borderRadius: "12px",
                            }}>
                            <CardBody style={{ padding: "0" }}>
                              <Webstories />
                            </CardBody>
                          </Card>
                        </Col>

                        <Col sm={6}>
                          <Card className="p-3" style={{ backgroundColor: '#1E253A' }}>
                            <div className="p-3">
                              <h5>
                                <Link to="/blog-details" className="text-light">
                                  What is Jantri?
                                </Link>
                              </h5>
                              <p className="text-muted mb-0">15 jan, 2025</p>
                            </div>

                            <div className="position-relative">
                              <Link to="/blog/what-is-jantri" >
                                <img
                                  src={img3}
                                  alt=""
                                  className="img-thumbnail"
                                />
                              </Link>
                            </div>

                            <div className="p-3">
                              <h3>
                                <Link to="/blog/what-is-jantri" className="text-light">
                                  How Does the Jantri Rate Affect Property Prices?
                                  How Does the Jantri Rate Affect Buyers and Sellers?
                                </Link>
                              </h3>

                              <div>
                                <Link to="/blog-list" className="text-primary">
                                  Read more{" "}
                                  <i className="mdi mdi-arrow-right"></i>
                                </Link>
                              </div>
                            </div>
                          </Card>
                        </Col>
                        <Col sm={6}>
                          <Card className="p-3" style={{ backgroundColor: '#1E253A' }}>
                            <div className="p-3">
                              <h5>
                                <Link to="/blog/what-is-jantri" className="text-light">
                                  What is Jantri?
                                </Link>
                              </h5>
                              <p className="text-muted mb-0">15 jan, 2025</p>
                            </div>

                            <div className="position-relative">
                              <Link to="/blog/what-is-jantri" >
                                <img
                                  src={img3}
                                  alt=""
                                  className="img-thumbnail"
                                />
                              </Link>
                            </div>

                            <div className="p-3">
                              <h3>
                                <Link to="/blog/what-is-jantri" className="text-light">
                                  How Does the Jantri Rate Affect Property Prices?
                                  How Does the Jantri Rate Affect Buyers and Sellers?
                                </Link>
                              </h3>

                              <div>
                                <Link to="/blog-list" className="text-primary">
                                  Read more{" "}
                                  <i className="mdi mdi-arrow-right"></i>
                                </Link>
                              </div>
                            </div>
                          </Card>
                        </Col>



                      </Row>

                      {/* <hr className="my-4" /> */}

                      {/* <div className="text-center">
                        <ul className="pagination justify-content-center pagination-rounded">
                          <li className="page-item disabled">
                            <Link to="#" className="page-link">
                              <i className="mdi mdi-chevron-left"></i>
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              1
                            </Link>
                          </li>
                          <li className="page-item active">
                            <Link to="#" className="page-link">
                              2
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              3
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              ...
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              10
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              <i className="mdi mdi-chevron-right"></i>
                            </Link>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  </Col>

                </Row>
              </div>
            </TabPane>
          </TabContent>
        </Card>

      </Col>

      {/* Footer */}
      <Footer />
    </React.Fragment>
  )
}
export default BlogGrid
